<template>
    <div class="projectManagement">
        <div class="tableCont">
            <div class="tabCont">
                <el-tabs
                    v-model="searchForm.status"
                    type="border-card"
                    @tab-click="project"
                    ref="tabs"
                >
                    <el-tab-pane
                        v-for="item in statusList"
                        :key="item.status"
                        :name="item.status"
                    >
                        <!-- <span
                            slot="label"
                            class="label"
                            v-show="item.name == '全部'"
                        >{{ item.name }}({{ item.total }})</span>
                        <span slot="label" class="label" v-show="item.name != '全部'">
                            {{ item.name }}
                            {{ item.total }}
                        </span> -->
                        <span slot="label" class="label">
                            <!-- <i class="el-icon-box"></i> -->
                            {{ item.name }}
                            {{ item.total }}
                        </span>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <el-drawer
                title="高级搜索"
                :visible.sync="drawerVisible"
                size="320px"
                class="drawerCont"
                ref="drawer"
                :wrapperClosable="false"
            >
                <el-scrollbar class="scrollbar">
                    <el-form
                        :model="searchForm"
                        label-width="120"
                        class="drawerForm"
                    >
                        <el-form-item label="项目名称" size="small">
                            <el-input
                                clearable
                                placeholder="请输入项目名称"
                                size="small"
                                v-model="searchForm.name"
                                @keydown.enter.native="project"
                            >
                            </el-input>
                            <!-- <el-select
                                v-model="searchForm.project_id"
                                filterable
                                placeholder="请选择项目名称"
                                clearable
                            >
                                <el-option
                                    v-for="item in projectList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select> -->
                        </el-form-item>
                        <el-form-item label="项目负责人" size="small">
                            <el-input
                                clearable
                                placeholder="请输入项目负责人"
                                size="small"
                                v-model="searchForm.lead_user_name"
                                @keydown.enter.native="project"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="项目类型" size="small">
                            <el-select
                                v-model="searchForm.type"
                                placeholder="请选择项目类型"
                                filterable
                                clearable
                                @change="project"
                            >
                                <el-option
                                    label="短期项目"
                                    value="1"
                                ></el-option>
                                <el-option
                                    label="长期项目"
                                    value="2"
                                ></el-option>
                                <el-option
                                    label="运维项目"
                                    value="3"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item label="状态" size="small">
                            <el-select
                                v-model="status_arr"
                                placeholder="请选择状态"
                                multiple
                                filterable
                                clearable
                            >
                                <el-option
                                    v-for="(item,i) of statusList"
                                    :key="i"
                                    :label="item.name"
                                    :value="item.status"
                                ></el-option>
                            </el-select>
                        </el-form-item>-->
                        <el-form-item style="text-align: right">
                            <el-button
                                type="danger"
                                icon="el-icon-refresh-right"
                                size="small"
                                @click="clean"
                                >重置条件</el-button
                            >
                        </el-form-item>
                    </el-form>
                </el-scrollbar>
                <div class="drawer-footer">
                    <el-button
                        style="width: 100%"
                        type="primary"
                        icon="el-icon-search"
                        size="small"
                        @click="project(1)"
                        >查询</el-button
                    >
                </div>
            </el-drawer>
            <div class="searchCont">
                <div class="searchContLeft">
                    <el-form
                        :inline="true"
                        :model="searchForm"
                        label-width="120"
                    >
                        <el-form-item label="项目名称" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入项目名称"
                                size="mini"
                                v-model="searchForm.name"
                                @keydown.enter.native="project"
                            >
                            </el-input>
                            <!-- <el-select
                                v-model="searchForm.project_id"
                                filterable
                                placeholder="请选择项目名称"
                                clearable
                            >
                                <el-option
                                    v-for="item in projectList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select> -->
                        </el-form-item>
                        <el-form-item label="项目负责人" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入项目负责人"
                                size="mini"
                                v-model="searchForm.lead_user_name"
                                @keydown.enter.native="project"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="项目类型" size="mini">
                            <el-select
                                v-model="searchForm.type"
                                placeholder="请选择项目类型"
                                filterable
                                clearable
                                @change="project"
                            >
                                <el-option
                                    label="短期项目"
                                    value="1"
                                ></el-option>
                                <el-option
                                    label="长期项目"
                                    value="2"
                                ></el-option>
                                <el-option
                                    label="运维项目"
                                    value="3"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <el-button
                        icon="el-icon-search"
                        size="mini"
                        type="primary"
                        style="margin-right: 10px"
                        @click="project(1)"
                    ></el-button>
                    <div v-if="this.menuAuth">
                        <template v-for="item in menuAuth.slice(0, 2)">
                            <el-button
                                type="primary"
                                :key="item.id"
                                :icon="item.icon"
                                size="mini"
                                @click="authFunc(item.funcName)"
                                >{{ item.name }}</el-button
                            >
                        </template>
                        <el-dropdown
                            v-if="menuAuth.length > 2"
                            @command="authFunc"
                            style="margin-left: 10px"
                        >
                            <el-button
                                type="primary"
                                size="mini"
                                icon="el-icon-arrow-down"
                                >更多操作</el-button
                            >
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    :key="item.id"
                                    v-for="item in menuAuth.slice(2)"
                                    :command="item.funcName"
                                >
                                    <i :class="item.icon"></i>
                                    {{ item.name }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div v-else></div>
                </div>
                <!-- 高级搜索 -->
                <advancedSearch :drawerVisible.sync="drawerVisible"
                    >高级搜索</advancedSearch
                >
            </div>

            <div class="table" :style="{ height: $store.state.index.screen }">
                <el-table
                    :data="tableData"
                    ref="tableData"
                    v-loading="loading"
                    highlight-current-row
                    height="100%"
                    @selection-change="handleSelectionChange"
                    @sort-change="sortChange"
                    :default-sort="{ prop: 'create_time', order: 'descending' }"
                >
                    <el-table-column
                        type="selection"
                        align="center"
                        :fixed="checkFixed"
                    ></el-table-column>
                    <el-table-column
                        label="优先级"
                        property="priority"
                        align="left"
                        width="90"
                        sortable
                    >
                        <template slot-scope="scope">
                            <p
                                class="priority"
                                :class="[
                                    scope.row.priority == 1
                                        ? 'priority1'
                                        : scope.row.priority == 2
                                        ? 'priority2'
                                        : scope.row.priority == 3
                                        ? 'priority3'
                                        : scope.row.priority == 4
                                        ? 'priority4'
                                        : '',
                                ]"
                            >
                                {{ scope.row.priority }}
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="项目名称"
                        property="name"
                        align="left"
                        show-overflow-tooltip
                        width="200"
                    ></el-table-column>
                    <el-table-column
                        label="项目类型"
                        property="type_cn"
                        align="left"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        label="项目时间"
                        align="left"
                        width="200"
                    >
                        <template slot-scope="scope">
                            <p>
                                {{ scope.row.start_date }} ~
                                {{ scope.row.end_date }}
                            </p>
                            <!-- <p>开始时间 : {{ scope.row.start_date }}</p>
                            <p v-if="scope.row.type == 1">
                                结束时间 : {{ scope.row.end_date }}
                            </p> -->
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="总天数"
                        property="total_days"
                        align="left"
                        width="70"
                    ></el-table-column>
                    <el-table-column
                        label="剩余天数"
                        property="surplus_days"
                        align="left"
                        width="70"
                    ></el-table-column>
                    <el-table-column
                        label="任务数"
                        property="job_num"
                        align="left"
                        width="80"
                    >
                        <template slot-scope="scoped">
                            <p
                                :class="[
                                    scoped.row.job_num > 0
                                        ? 'link'
                                        : 'cursor_not_allowed',
                                ]"
                                @click="jump(scoped.row)"
                            >
                                {{ scoped.row.job_num }}
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="负责人"
                        property="lead_user_name"
                        align="left"
                        width="100"
                    >

                      <template slot-scope="scope">
                        <div class="nameCont">
                          <div class="headImg" >
                            <el-avatar v-if="scope.row.lead_user_avatar!=''"
                                       size="small"
                                       :src="scope.row.lead_user_avatar"
                            ></el-avatar>
                            <span v-else>
                    <el-avatar
                        size="small"
                        :src="'https://uc-api.loratech.cn/dingtalk/2/user/'+encodeURIComponent(scope.row.lead_user_name)+'/avatar/50'"
                    ></el-avatar></span>

                          </div>
                          <div class="memberName">
                            {{ scope.row.lead_user_name }}
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        label="团队人数"
                        property="team_num"
                        align="left"
                        width="80"
                    ></el-table-column>
                    <el-table-column
                        label="总进度"
                        property="progress"
                        align="left"
                        width="160"
                    >
                        <template slot-scope="scope">
                            <el-progress
                                :percentage="scope.row.progress"
                                :stroke-width="10"
                            ></el-progress>
                        </template>
                    </el-table-column>
                    <el-table-column label="当前状态" align="left" width="80">
                        <template slot-scope="scope">
                            <el-tag
                                size="mini"
                                :type="
                                    scope.row.status == 1
                                        ? 'info'
                                        : scope.row.status == 5
                                        ? 'warning'
                                        : scope.row.status == 10
                                        ? 'success'
                                        : scope.row.status == 20 ||
                                          scope.row.status == 99
                                        ? 'danger'
                                        : ''
                                "
                                >{{ scope.row.status_cn }}</el-tag
                            >
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="里程碑"
                        property
                        width="80"
                        align="left"
                    >
                        <template slot-scope="scope">
                            <i
                                class="el-icon-pie-chart milestone"
                                @click="
                                    milestoneVisible = true;
                                    tableItem = scope.row;
                                "
                            ></i>
                            <!-- {{ scope.row. == 0 ? "" : "" }} -->
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="创建人"
                        property="user_name"
                        width="100"
                        align="left"
                    >
                      <template slot-scope="scope">
                        <div class="nameCont">
                          <div class="headImg" >
                            <el-avatar v-if="scope.row.user_avatar!=''"
                                       size="small"
                                       :src="scope.row.user_avatar"
                            ></el-avatar>
                            <span v-else>
                    <el-avatar
                        size="small"
                        :src="'https://uc-api.loratech.cn/dingtalk/2/user/'+encodeURIComponent(scope.row.user_name)+'/avatar/50'"
                    ></el-avatar></span>

                          </div>
                          <div class="memberName">
                            {{ scope.row.user_name }}
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        label="创建时间"
                        width="140"
                        property="create_time"
                        align="left"
                        sortable
                    ></el-table-column>
                    <el-table-column
                        label="操作"
                        align="left"
                        width="200"
                        :fixed="operationFixed"
                    >
                        <template slot-scope="scope">
                            <div class="operation-btns">
                                <span
                                    v-for="item in scope.row.authority"
                                    :key="item.id"
                                >
                                    <el-button
                                        v-if="item.status_flag != 4"
                                        type="text"
                                        size="small"
                                        class="color-blue"
                                        :class="
                                            item.name == '删除' ? 'redText' : ''
                                        "
                                        @click="rowDo(scope.row, item)"
                                        >{{ item.name }}</el-button
                                    >
                                    <popConfirm
                                        v-else-if="item.status_flag == 4"
                                        :title="item.name"
                                        :buttonText="item.name"
                                        @confirm="rowDo(scope.row, item)"
                                    >
                                    </popConfirm>
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <pagination
                :paginationData="paginationData"
                @paginationChange="paginationChange"
            ></pagination>

            <projectAdd :addVisible.sync="addVisible"></projectAdd>
            <projectEdit
                :editVisible.sync="editVisible"
                :tableItem="tableItem"
            ></projectEdit>
            <projectDetail
                :detailVisible.sync="detailVisible"
                :tableItem="tableItem"
            ></projectDetail>
            <projectReport
                :reportVisible.sync="reportVisible"
                :tableItem="tableItem"
            ></projectReport>
            <projectMilestone
                :milestoneVisible.sync="milestoneVisible"
                :tableItem="tableItem"
            ></projectMilestone>
        </div>
    </div>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
import { tableMixin } from "@/utils/tableMixins.js";
import pagination from "@/comon/components/pagination";
import advancedSearch from "@/comon/components/advancedSearch";
import popConfirm from "@/comon/components/popConfirm";

export default {
    mixins: [tableMixin],

    data() {
        return {
            searchForm: {
                name: "",
                lead_user_name: "",
                type: "",
                status: "0",
            },
            menuId: "",
            tableData: [],

            paginationData: {
                page: 1,
                "per-page": 20,
                total: "",
            },

            tableItem: [],
            detailVisible: false,
            addVisible: false,

            selectionUserIdList: [],

            drawerVisible: false,
            editVisible: false,
            statusList: [],
            detailVisible: false,
            reportVisible: false,
            milestoneVisible: false,
            orderby_create_time: null,
            orderby_priority: null,
            projectList: [],
        };
    },
    methods: {
        detail(row) {
            this.tableItem = row;
            this.detailVisible = true;
        },
        add() {
            this.addVisible = true;
        },
        clean() {
            this.searchForm = {
                name: "",
                lead_user_name: "",
                type: "",
                status: "0",
            };
            this.project();
        },
        export() {
            oaApi.interviewBatchExport().then((res) => {
                if (res) {
                    window.open(res.data.url);
                }
            });
        },
        /**
         * 批量删除
         */
        batchDel() {
            if (this.selectionUserIdList.length > 0) {
                this.$confirm("是否批量删除选中的数据?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        oaApi
                            .eventsBatchDelete({
                                ids: this.selectionUserIdList.toString(),
                            })
                            .then((res) => {
                                if (res.code == 200) {
                                    this.$message.success("删除成功！");
                                    this.project();
                                } else {
                                    this.$message.error("删除失败！");
                                }
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            } else {
                this.$message.warning("请勾选要删除的数据");
            }
        },
        closeDrawer() {
            this.drawerVisible = false;
        },
        /**
         * 获取项目列表
         */
        project(page) {
            page ? (this.paginationData.page = 1) : "";
            oaApi
                .project(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        orderby_create_time: this.orderby_create_time,
                        orderby_priority: this.orderby_priority,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.statusList = res.ext.tabs;
                        this.$nextTick(() => {
                            this.$refs.tableData.doLayout();
                            // this.resetTabActivePosition(this.$refs.tabs.$el);
                        });
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.$refs.tableData.bodyWrapper.scrollTop = 0;
                        this.closeDrawer();
                    }
                });
        },

        resetTabActivePosition($el) {
            var activeEl = $el.querySelector(".el-tabs__item.is-active");
            var lineEl = $el.querySelector(".el-tabs__active-bar");
            if (activeEl) {
                var style = getComputedStyle(activeEl);
                var pl = style.paddingLeft.match(/\d+/)[0] * 1;
                var pr = style.paddingRight.match(/\d+/)[0] * 1;
                var w = style.width.match(/\d+/)[0] * 1;
                lineEl.style.transform =
                    "translateX(" + (activeEl.offsetLeft + pl) + "px)";
                lineEl.style.width = w - pl - pr + "px";
            }
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.project();
        },
        /**
         * 根据table数据循环事件分发
         */
        rowDo(row, item) {
            if (item.name == "查看") {
                this.detail(row);
            } else if (item.name == "编辑") {
                this.edit(row);
            } else if (item.name == "删除") {
                this.$confirm(`确定${item.name}?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() =>
                        oaApi.project({}, "delete", row.id).then((res) => {
                            if (res) {
                                if (res.code == 200) {
                                    this.$message.success(`${item.name}成功`);
                                    this.project();
                                }
                            }
                        })
                    )
                    .catch(() => {
                        this.$message.info("已取消操作");
                    });
            } else if (item.name == "开始") {
                this.projectUpdateStatus(item, row.id, 5);
            } else if (item.name == "完成") {
                this.projectUpdateStatus(item, row.id, 10);
            } else if (item.name == "取消") {
                this.projectUpdateStatus(item, row.id, 99);
            } else if (item.name == "汇报") {
                this.reportVisible = true;
                this.tableItem = row;
            }
        },
        edit(row) {
            this.tableItem = row;
            this.editVisible = true;
        },
        authFunc(funcName) {
            this[funcName]();
        },
        handleSelectionChange(val) {
            this.selectionUserIdList = [];
            for (let i in val) {
                this.selectionUserIdList.push(val[i].id);
            }
        },
        projectUpdateStatus(item, id, status) {
            /* this.$confirm(`确定${item.name}?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => */
            oaApi.projectUpdateStatus({ id, status }, "post").then((res) => {
                if (res) {
                    if (res.code == 200) {
                        this.$message.success(`${item.name}成功`);
                        this.project();
                    }
                }
            });
            /* )
                .catch(() => {
                    this.$message.info("已取消操作");
                }); */
        },
        jump(row) {
            if (row.job_num > 0) {
                this.$router.push({
                    path: "/jobManagement",
                    query: {
                        project_id: row.id,
                    },
                });
            }
        },
        sortChange(column) {
            if (column.prop == "priority") {
                if (column.order == "descending") {
                    this.orderby_priority = "desc";
                } else if (column.order == "ascending") {
                    this.orderby_priority = "asc";
                } else if (column.order == null) {
                    this.orderby_priority = null;
                }
            } else if (column.prop == "create_time") {
                if (column.order == "descending") {
                    this.orderby_create_time = "desc";
                } else if (column.order == "ascending") {
                    this.orderby_create_time = "asc";
                } else if (column.order == null) {
                    this.orderby_create_time = null;
                }
            }
            this.project();
        },
        /**
         * 获取项目下拉菜单
         */
        projectSelect() {
            oaApi.projectSelect({}, "get").then((res) => {
                if (res.code == 200) {
                    this.projectList = res.data;
                }
            });
        },
    },
    created() {
        this.project();
        // this.projectSelect();
    },
    components: {
        pagination: pagination,
        advancedSearch: advancedSearch,
        popConfirm: popConfirm,
        projectAdd: () => import("./projectManagement/add.vue"),
        projectEdit: () => import("./projectManagement/edit.vue"),
        projectDetail: () => import("./projectManagement/detail.vue"),
        projectReport: () => import("./projectManagement/report.vue"),
        projectMilestone: () => import("./projectManagement/milestone.vue"),
    },
    watch: {
        perPage: {
            handler(newValue) {
                this.perPage = newValue;
                this.project();
            },
            deep: true,
            immediate: false,
        },
        page: {
            handler(newValue) {
                this.page = newValue;
                this.project();
            },
            deep: true,
            immediate: false,
        },
    },
    computed: {
        menuAuth() {
            return this.$store.state.menu.menuAuth;
        },
        menu_id() {
            return this.$store.state.menu.menu_id
                ? this.$store.state.menu.menu_id
                : localStorage.getItem("menu_id");
        },
    },
};
</script>
<style lang="scss">
.projectManagement {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    .tableCont {
        // width: calc(100% - 250px);
        width: 100%;
        height: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        .table {
            width: 100%;
            scrollbar-width: thin;
            // padding: 0 20px;
            // .el-scrollbar__wrap {
            //     overflow-x: hidden;
            // }
          .nameCont {
            display: flex;
            align-items: center;
            justify-content: start;
            .headImg {
              height: 28px;
              width: 28px;
              border-radius: 8px;
              overflow: hidden;
              margin-right: 8px;
              justify-items: flex-start;
              img{
                width: 100%;
              }
            }
            .memberName {
              line-height: 24px;
            }
          }
            .milestone {
                font-size: 16px !important;
                cursor: pointer;
                &:active {
                    opacity: 0.8;
                }
            }
            .el-progress {
                .el-progress__text {
                    min-width: 31px;
                }
            }
        }
    }
}
</style>
